var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16304_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7833 10.1754H5.78334C5.23106 10.1754 4.78334 10.6231 4.78334 11.1754V15.1754C4.78334 15.7277 5.23106 16.1754 5.78334 16.1754H27.7833C28.3356 16.1754 28.7833 15.7277 28.7833 15.1754V11.1754C28.7833 10.6231 28.3356 10.1754 27.7833 10.1754Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7833 16.1754V25.1754C26.7833 25.4406 26.678 25.695 26.4904 25.8825C26.3029 26.07 26.0486 26.1754 25.7833 26.1754H7.78334C7.51812 26.1754 7.26377 26.07 7.07623 25.8825C6.8887 25.695 6.78334 25.4406 6.78334 25.1754V16.1754",
    stroke: "#FAFAFA",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7833 10.1754V26.1754",
    stroke: "#FAFAFA",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8821 4.07664C24.0496 5.24414 24.1183 7.20914 22.8821 8.30414C20.7683 10.1754 16.7833 10.1754 16.7833 10.1754C16.7833 10.1754 16.7833 6.19039 18.6583 4.07664C19.7496 2.84039 21.7146 2.90914 22.8821 4.07664Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6846 4.07664C9.5171 5.24414 9.44835 7.20914 10.6846 8.30414C12.7983 10.1754 16.7833 10.1754 16.7833 10.1754C16.7833 10.1754 16.7833 6.19039 14.9083 4.07664C13.8171 2.84039 11.8521 2.90914 10.6846 4.07664Z",
    stroke: "#FAFAFA",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16304_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.78334 0.175385)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.cbd729a34d08e83dcb6332739fa9459c.svg";
export { ForwardRef as ReactComponent };